import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import LatticeLoader from '@ui/components/vendor/react-bits/LatticeLoader/LatticeLoader';
import { microBrand } from './brand';
import './activity-indicator.scss';
const SIZES = {
    sm: { cell: 4, gap: 2, font: 13 },
    md: { cell: 6, gap: 3, font: 14 },
    lg: { cell: 8, gap: 4, font: 15 }
};
/** Brand-coloured React Bits Lattice Loader without the "Thinking" label and stopwatch. */
export const ActivityIndicator = ({ label = 'Loading…', size = 'md', announce = false, className }) => {
    const dimensions = SIZES[size];
    const style = {
        '--ai-cell': `${dimensions.cell}px`,
        '--ai-gap': `${dimensions.gap}px`,
        '--ai-font': `${dimensions.font}px`,
        '--ai-idle': microBrand.accentMarkIdle,
        '--ai-text': microBrand.text
    };
    return (_jsxs("span", { className: `activity-indicator${className ? ` ${className}` : ''}`, style: style, role: announce ? 'status' : undefined, children: [_jsxs("span", { className: 'activity-indicator__lattice', "aria-hidden": 'true', children: [microBrand.twoToneIndicator ? (_jsx("span", { className: 'activity-indicator__underlay', children: Array.from({ length: 9 }, (_, index) => (_jsx("span", { "data-hole": index === 4 ? '' : undefined }, index))) })) : null, _jsx(LatticeLoader, { label: '', doneLabel: '', errorLabel: '', showTimer: false, pattern: 'orbit', grid: 3, shape: 'round', color: microBrand.accentMark, idleOpacity: microBrand.twoToneIndicator ? 0 : microBrand.markIdleOpacity, cellSize: dimensions.cell, gap: dimensions.gap, step: 115, glow: false })] }), label ? _jsx("span", { className: 'activity-indicator__label', children: label }) : null] }));
};
